import * as React from 'react';
import { Dropdown, Image } from "react-bootstrap";
import { ChangeBankingDetailsForm } from './ChangeBankingDetailsForm';
import './LifeChangeBankingDetailsForm.css';
import { PremiumPayerPersonalDetailsForm } from './PremiumPayerPersonalDetailsForm';

export interface ChangeBankingDetailsFormProps {
    bankingDetails: {
        accountType: string;
        accountNumber: string;
        bankName: string;
        branchCode: string;
        premiumPayerType: string;
        email?: string;
        relationship?: string;
        phoneNumber?: string;
        idNumber?: string;
        name?: string;
        surname?: string;
        notes?: string;
        title?: string;
    };
    accountTypeList: {text: string, value: string}[];
    bankInfoList: {id?: string, name: string, avs?: boolean, avsRealtime?: boolean, debiCheck?: boolean, debiCheckRealtime?: boolean, branchCode?: string}[];
    emitHandleChange: any;
    disableForm?: boolean;
    debitOrderDate: any;
    debitDayList: { text: string, value: string }[];
    bankInfoLoading: boolean;
}

interface State {
    bankName: string;
    branchCode: string;
    accountType: string;
    accountNumber: string;
    premiumPayerType: string;
    premiumPayerTypes: string[];
    premiumPayerAccordionState: boolean;
    debitOrderDate: string;
    debitOrderDateAccordionState: boolean;
}

export class LifeChangeBankingDetailsForm extends React.Component<ChangeBankingDetailsFormProps, State> {
    constructor(props: ChangeBankingDetailsFormProps) {
        super(props);
        this.state = {
            accountNumber: this.props.bankingDetails?.accountNumber ? this.props.bankingDetails.accountNumber: '',
            accountType: this.props.bankingDetails?.accountType ? this.props.bankingDetails.accountType : '',
            bankName: this.props.bankingDetails?.bankName ? this.props.bankingDetails.bankName : '',
            branchCode: this.props.bankingDetails?.branchCode ? this.props.bankingDetails.branchCode : '',
            premiumPayerType: this.props.bankingDetails?.premiumPayerType ? this.props.bankingDetails.premiumPayerType : 'Policyholder',
            premiumPayerTypes: [
                'Policyholder',
                'Someone else'
            ],
            debitOrderDate: this.props.debitOrderDate,
            debitOrderDateAccordionState: false,
            premiumPayerAccordionState: false,
        };
        
        this.handleChange = this.handleChange.bind(this);
        this.handleInnerChange = this.handleInnerChange.bind(this);
        //this.handleDropdownChange = this.handleDropdownChange.bind(this);

        this.handlePremiumPayerTypeSelection = this.handlePremiumPayerTypeSelection.bind(this);
        this.handlePremiumPayerTypeDropdownToggle = this.handlePremiumPayerTypeDropdownToggle.bind(this);

        this.handleDebitOrderDateSelection = this.handleDebitOrderDateSelection.bind(this);
        this.handleDebitOrderDateDropdownToggle = this.handleDebitOrderDateDropdownToggle.bind(this);
    }


    async handleChange(e: any) {
        const value: string = e.target.value;
        const key: string = e.target.name;

        e.persist();

        this.props.emitHandleChange({ [key]: value });
    }

    async handleInnerChange(e: any) {
        this.props.emitHandleChange(e);
    }

    async handlePremiumPayerTypeSelection(e: any) {
        this.handleInnerChange({ premiumPayerType: e });
    }

    async handlePremiumPayerTypeDropdownToggle(e: any) {
        this.setState({
            premiumPayerAccordionState: e
        });
    }

    async handleDebitOrderDateSelection(e: any) {
        this.handleInnerChange({debitOrderDate: e});
    }

    async handleDebitOrderDateDropdownToggle(e: any) {
        this.setState({
            debitOrderDateAccordionState: e
        });
    }
    
    public render() {
        return (
            <>
                <div className="col-12 change-banking-details__control">
                    <Dropdown id="ChooseItem"
                        onSelect={this.handlePremiumPayerTypeSelection}
                        onToggle={this.handlePremiumPayerTypeDropdownToggle}>
                        <Dropdown.Toggle id="dropdown-basic">
                            <>
                                {this.props.bankingDetails.premiumPayerType &&
                                    <>
                                        <p className="title mb-1 change-banking-details__label"><b>Who will pay the premium</b></p>
                                    <div className="choose-item__selected">
                                        <p className="choose-item__text hide-overflow noma">{this.props.bankingDetails.premiumPayerType}</p>
                                            <a className="choose-item__arrow">
                                                { !this.state.premiumPayerAccordionState && <Image className="choose-item__arrow-icon" src="./Images/Claims/dropdown-inline-icon.png" /> }
                                                { this.state.premiumPayerAccordionState === true && <Image className="choose-item__arrow-icon" src="./Images/Claims/dropdown-up-inline-icon.png" /> }
                                            </a>
                                        </div>
                                    </>
                                }
                                {!this.props.bankingDetails.premiumPayerType &&
                                    <p>Choose an item</p>
                                }
                            </>
                        </Dropdown.Toggle>
                        <Dropdown.Menu title="Choose an item" id="nav-dropdown">
                            { this.state.premiumPayerTypes.map((premiumPayerType, idx) => {
                                return <Dropdown.Item eventKey={premiumPayerType} key={premiumPayerType} value={premiumPayerType}>
                                    {premiumPayerType}
                                    {(idx != this.state.premiumPayerTypes.length - 1) && <hr className="cover-divider" />}
                                    </Dropdown.Item>
                            }) }
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                { this.props.bankingDetails.premiumPayerType == "Someone else" &&
                    <>
                        <div className="col-12 nopa">
                            <p><b>Premium payer’s personal details</b></p>
                        </div>
                        <div className="col-12 nopa">
                            <p>Please fill in the details of the premium payer only</p>
                        </div>
                        <PremiumPayerPersonalDetailsForm
                        emitHandleChange={this.handleInnerChange}
                        relationshipList={['Child', 'Spouse']}
                        titleList={['Mr', 'Mrs']}
                        disableForm={false}
                        email={this.props.bankingDetails.email}
                        idNumber={this.props.bankingDetails.idNumber}
                        name={this.props.bankingDetails.name}
                        phoneNumber={this.props.bankingDetails.phoneNumber}
                        notes={this.props.bankingDetails.notes}
                        relationship={this.props.bankingDetails.relationship}
                        surname={this.props.bankingDetails.surname}
                        title={this.props.bankingDetails.title}
                        />
                        <div className="col-12 nopa">
                            <p><b>Premium payer's payment details</b></p>
                        </div>
                        <div className="col-12 nopa">
                            <p>Please fill in the payment details of the premium payer only</p>
                        </div>
                    </>
                }
                <ChangeBankingDetailsForm bankInfoLoading={this.props.bankInfoLoading} emitHandleChange={this.handleInnerChange} disableForm={this.props.disableForm} accountTypeList={this.props.accountTypeList} bankInfoList={this.props.bankInfoList} bankingDetails={this.props.bankingDetails} />
                <div className="col-12 change-banking-details__control">
                    <Dropdown id="ChooseItem"
                        onSelect={this.handleDebitOrderDateSelection}
                        onToggle={this.handleDebitOrderDateDropdownToggle}>
                        <Dropdown.Toggle id="dropdown-basic" >
                            <>
                                {this.props.debitOrderDate &&
                                    <>
                                        <p className="title mb-1 change-banking-details__label"><b>Debit order date</b></p>
                                        <div className="choose-item__selected">
                                            <p className="choose-item__text hide-overflow noma">{this.props.debitOrderDate}</p>
                                            <a className="choose-item__arrow">
                                                {!this.state.debitOrderDateAccordionState && <Image className="choose-item__arrow-icon" src="./Images/Claims/dropdown-inline-icon.png" />}
                                                {this.state.debitOrderDateAccordionState === true && <Image className="choose-item__arrow-icon" src="./Images/Claims/dropdown-up-inline-icon.png" />}
                                            </a>
                                        </div>
                                    </>
                                }
                                {!this.props.debitOrderDate &&
                                    <p>Choose an item</p>
                                }
                            </>
                        </Dropdown.Toggle>
                        <Dropdown.Menu title="Choose an item" id="nav-dropdown">
                            { this.props.debitDayList && this.props.debitDayList.map((debitDayOption, idx) => {
                                return <Dropdown.Item eventKey={debitDayOption.text} key={debitDayOption.text} value={debitDayOption.text}>
                                    {debitDayOption.text}
                                    {(idx != this.props.debitDayList.length - 1) && <hr className="cover-divider" />}
                                </Dropdown.Item>
                            })}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </>
        )
    }
}
